import React from "react";
import { ReactComponent as DownArrow } from "../../assets/images/svg/downarrow.svg";

const ReportsMenuButton = ({ activeTab, title, name }) => {
  return (
    <div
      className={`navigation arrow report-navigation ${
        activeTab === name ? "is-active" : ""
      }`}
    >
      {title}
      <DownArrow />
    </div>
  );
};

export default ReportsMenuButton;
